// Hvilken fil hver side ligger i. App.tsx og kontorets ramme (Skal.tsx) henter siderne herfra, når de vises (senere.ts),
// og main.tsx henter den side, adressen peger på, med det samme – samtidig med resten, i stedet for bagefter.
import { husk } from './senere';

export const FIL = {
  pixie: husk(() => import('./sider/Pixie')),
  pixieForside: husk(() => import('./sider/PixieForside')),
  abonnement: husk(() => import('./sider/admin/Abonnement')),
  hjemmeside: husk(() => import('./sider/kunde/Hjemmeside')),
  indlejring: husk(() => import('./sider/kunde/IndlejringVis')),
  ekstra: husk(() => import('./sider/Ekstra')),
  start: husk(() => import('./sider/Start')),
  login: husk(() => import('./sider/Login')),
  booking: husk(() => import('./sider/kunde/Booking')),
  partner: husk(() => import('./sider/kunde/Partner')),
  mine: husk(() => import('./sider/kunde/Mine')),
  loginLink: husk(() => import('./sider/kunde/LoginLink')),
  afmeld: husk(() => import('./sider/kunde/Afmeld')),
  nyhedAfmeld: husk(() => import('./sider/kunde/NyhedAfmeld')),
  anmeld: husk(() => import('./sider/kunde/Anmeld')),
  betalingRetur: husk(() => import('./sider/kunde/BetalingRetur')),
  kundecenter: husk(() => import('./sider/kunde/Kundecenter')),
  godkend: husk(() => import('./sider/kunde/Godkend')),
  nyTid: husk(() => import('./sider/kunde/NyTid')),
  udlaeg: husk(() => import('./sider/Udlaeg')),
  admin: husk(() => import('./sider/admin/Skal')),
  steamer: husk(() => import('./sider/steamer/Steamer')),
  // Kontorets sider
  overblik: husk(() => import('./sider/admin/IDag')),
  dashboard: husk(() => import('./sider/admin/Dashboard')),
  kalender: husk(() => import('./sider/admin/Kalender')),
  log: husk(() => import('./sider/admin/Aktivitetslog')),
  bookinger: husk(() => import('./sider/admin/Bookinger')),
  betalinger: husk(() => import('./sider/admin/Betalinger')),
  rykkere: husk(() => import('./sider/admin/Rykkere')),
  oprydning: husk(() => import('./sider/admin/Oprydning')),
  kunder: husk(() => import('./sider/admin/Kunder')),
  service: husk(() => import('./sider/admin/Service')),
  kundecenterAdmin: husk(() => import('./sider/admin/Kundecenter')),
  chatbot: husk(() => import('./sider/admin/Chatbot')),
  chatWidget: husk(() => import('./sider/kunde/ChatWidget')),
  ressourcer: husk(() => import('./sider/admin/Ressourcer')),
  subdomaener: husk(() => import('./sider/admin/Subdomaener')),
  partnere: husk(() => import('./sider/admin/Partnere')),
  medlemskaber: husk(() => import('./sider/admin/Medlemskaber')),
  opsaetning: husk(() => import('./sider/admin/Opsaetning')),
  brugere: husk(() => import('./sider/admin/Brugere')),
  automatisering: husk(() => import('./sider/admin/Automatisering')),
  chat: husk(() => import('./sider/Chat')),
  kort: husk(() => import('./sider/admin/Kort')),
  crm: husk(() => import('./sider/admin/Crm')),
  ansoegninger: husk(() => import('./sider/admin/Ansoegninger')),
  mersalg: husk(() => import('./sider/admin/Mersalg')),
  anmeldelser: husk(() => import('./sider/admin/Anmeldelser')),
  marketing: husk(() => import('./sider/admin/marketing/Marketing')),
  analyse: husk(() => import('./sider/admin/Analyse')),
  omkostninger: husk(() => import('./sider/admin/Omkostninger')),
  loen: husk(() => import('./sider/admin/Loen')),
};
type Fil = keyof typeof FIL;

/** Adressens første led → filen. */
const TOP: Record<string, Fil> = {
  book: 'booking', medlem: 'booking', bekraeftelse: 'booking', p: 'partner', hjemmeside: 'hjemmeside', indlejring: 'indlejring', login: 'login', glemt: 'login',
  nulstil: 'login', invitation: 'login', kundecenter: 'kundecenter', ekstra: 'ekstra', godkend: 'godkend', 'ny-tid': 'nyTid', udlaeg: 'udlaeg', link: 'loginLink',
  af: 'afmeld', chat: 'chatWidget', nyhedsbrev: 'nyhedAfmeld', betaling: 'betalingRetur', anmeld: 'anmeld', mine: 'mine', admin: 'admin', steamer: 'steamer', start: 'start',
};
/** Kontorets side → filen. */
const ADMIN: Record<string, Fil> = {
  overblik: 'overblik', kalender: 'kalender', smartplan: 'kalender', log: 'log', dashboard: 'dashboard', chat: 'chat', kort: 'kort', udlaeg: 'udlaeg',
  'mine-udlaeg': 'udlaeg', mersalg: 'mersalg', anmeldelser: 'anmeldelser', crm: 'crm', afventer: 'bookinger', bookinger: 'bookinger', betalinger: 'betalinger',
  rykkere: 'rykkere', oprydning: 'oprydning', kunder: 'kunder', kundecenter: 'kundecenterAdmin', chatbot: 'chatbot', beskeder: 'service', ydelser: 'ressourcer', steamere: 'ressourcer', zoner: 'ressourcer',
  kuponer: 'ressourcer', ansoegninger: 'ansoegninger', subdomaener: 'subdomaener', partnere: 'partnere', medlemskaber: 'medlemskaber',
  indstillinger: 'opsaetning', felter: 'opsaetning', integrationer: 'opsaetning', brugere: 'brugere', automatiseringer: 'automatisering',
  kampagner: 'marketing', forloeb: 'marketing', mailskabeloner: 'marketing', modtagere: 'marketing', nyhedsindstillinger: 'marketing',
  analyse: 'analyse', omkostninger: 'omkostninger', loen: 'loen',
};
const opslag = (m: Record<string, Fil>, n: string) => (Object.hasOwn(m, n) ? m[n] : undefined);
const hent = (f: Fil | undefined) => { if (f) void FIL[f]().catch(() => { /* hentes igen, når siden vises */ }); };

/** Testversionen (én fil): alle sider ligger allerede i filen – gør dem klar med det samme, så ingen side viser "Henter …". */
export function forudHentAlle(): void { for (const f of Object.keys(FIL) as Fil[]) hent(f); }

/** Begynd at hente siden for en intern sti (fx /admin/smartplan) med det samme. Ukendte stier: intet. */
export function forudHent(sti: string): void {
  const [s0 = '', s1 = 'overblik'] = sti.split('?')[0].split('/').filter(Boolean);
  hent(s0 === 'pixie' ? (s1 === 'konsol' ? 'pixie' : 'pixieForside') : opslag(TOP, s0));
  if (s0 === 'admin') hent(opslag(ADMIN, s1));
}
